export const text = {
  Employees: "Employees",
  Employee: "Employee",
  FullName: "Full Name",
  EmployeeNumber: "Employee Number",
  CompanyEmail: "Company Email",
  Gender: "Gender",
  DateofBirth: "Date of Birth",
  DateofJoining: "Date of Joining",
  AddEmployees: "Add Employees",
  Onboarding: "Onboarding",
  Details: "Details",
  AssignedApps: "Assigned Apps",
  MyDevelopment: "My Development",
  Academy: "Academy",
  MyTeam: "My Team",
  PersonalInformation: "Personal Information",
  EnterFirstName: "Enter First Name",
  EnterMiddleName: "Enter Middle Name",
  EnterLastName: "Enter Last Name",
  EnterFullName: "Enter Full Name",
  EnterEmail: "Enter Email",
  Day: "Day",
  Areyousureyouwanttodeletethis: "Are you sure you want to delete this ?",
  Goals: "Goals",
  GoalAttachments: "Goal Attachments",
  MydevelopmentForms: "My development Forms",
  Goal: "Goal",
  StartDate: "Start Date",
  EndDate: "End Date",
  Attachment: "Attachment",
  FileName: "File Name",
  UploadDate: "Upload Date",
  Form: "Form",
  Course: "Course",
  Address: "Address",
  DisableEmployee: "Disable Employee",
  chooseProfile: "Choose Profile",
  CompanyInformation: "Company Information",
  Team: "Team",
  CompanyEmail: "Company Email",
  Designation: "Designation",
  ReportingManager: "Reporting Manager",
  IsHR: "Is HR?",
  ModuleName: "Module Name",
  AssignedModule: "Assigned Module",
  AllowNotifications: "Allow Notifications",
  OnboardingTemplate: "Onboarding Template",
  OnboardingStartdate: "Onboarding Start date",
  OnboardingQuizReport: "Onboarding Quiz Report",
  Tasks: "Tasks",
  TaskType: "Task Type",
  Task: "Task",
  Date: "Date",
  Status: "Status",
  Category: "Category",
  TotalPoint: "Total Point",
  AssignedTeam: "Assigned Team",
  Employeeaddedsuccessfully: "Employee added successfully!",
  Pleasecompletethe: "Please complete the",
  fields: "fields",
  field: "field",
  AddEmployees: "Add Employees",
  NewEmployee: "New Employee",
  Male: "Male",
  Female: "Female",
  Other: "Other",
  EnterEmployeeNumber: "Enter Employee Number",
  EnterCompanyEmail: "Enter Company Email",
  Employeeupdatedsuccessfully: "Employee updated successfully!",
  EmployeeName: "Employee Name",
  EmployeeNumber: "Employee Number",
  Quiz: "Quiz",
  Question: "Question",
  Option: "Option",
  Report: "Report",
  Answer: "Answer",
  SelectEmployeeTaskType: "Select Employee Task Type",
  TaskType: "Task Type",
  Documentation: "Documentation",
  Video: "Video",
  Quiz: "Quiz",
  Image: "Image",
  EnterPhoneNumber: "Enter Phone Number",
  PhoneNumber: "Phone Number",
  Language: "Language",
  Completed: "Completed",
  Pending: "Pending",
  Overdue: "Overdue",
  Submitted: "Submitted",
  Rejected: "Rejected",
  Approved: "Approved",
  Poll: "Poll",
  Subjective: "Subjective",
  Objective: "Objective",
  Disabled: "Disable",
  Enabled: "Enable",
  disabled: "disable",
  enabled: "enable",
};
